import { render, staticRenderFns } from "./Myorder.vue?vue&type=template&id=038a49fe&scoped=true&"
import script from "./Myorder.vue?vue&type=script&lang=js&"
export * from "./Myorder.vue?vue&type=script&lang=js&"
import style0 from "./Myorder.vue?vue&type=style&index=0&id=038a49fe&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "038a49fe",
  null
  
)

export default component.exports